import { useState, useEffect } from "react";

function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    function update() {
      const now = new Date();
      const deadline = new Date(now);
      deadline.setDate(deadline.getDate() + 2);
      deadline.setHours(23, 59, 0, 0);
      const diff = deadline - now;
      if (diff <= 0) { setTimeLeft("00:00:00"); return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`);
    }
    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, []);

  const deadline = new Date();
  deadline.setDate(deadline.getDate() + 2);
  const dateStr = deadline.toLocaleDateString("en-US", { month: "long", day: "numeric" });

  return (
    <div style={{
      background: "#1a1a2e", color: "#fff", padding: "10px 20px",
      textAlign: "center", fontSize: 13, fontWeight: 500,
      display: "flex", alignItems: "center", justifyContent: "center",
      gap: 8, flexWrap: "wrap",
    }}>
      <span style={{ color: "#f59e0b", fontWeight: 700 }}>⚡ Price increases to $20/month on {dateStr} at 11:59PM ET</span>
      <span style={{ color: "#94a3b8" }}>—</span>
      <span>Lock in <strong style={{ color: "#22c55e" }}>$15/month</strong> now or pay more later.</span>
      <span style={{ color: "#f59e0b", fontWeight: 700, fontFamily: "monospace", fontSize: 14 }}>{timeLeft}</span>
      <span style={{ color: "#64748b" }}>remaining</span>
    </div>
  );
}

const DEMO_TOPICS = [
  { topic: "Passive Income for Teachers", score: 82, virality: "High", competition: "Moderate", audience: "Teachers 25-45" },
  { topic: "AI Tools Every Freelancer Needs", score: 91, virality: "Explosive", competition: "Low", audience: "Freelancers, Side hustlers" },
  { topic: "Budget Travel on $50/day", score: 74, virality: "High", competition: "Competitive", audience: "Young travellers 22-35" },
  { topic: "Starting a Dropshipping Store in 2026", score: 68, virality: "Moderate", competition: "Competitive", audience: "New entrepreneurs" },
  { topic: "Mental Health Toolkit for Entrepreneurs", score: 85, virality: "High", competition: "Low", audience: "Founders, Solopreneurs" },
];

function scoreColor(s) {
  if (s >= 75) return "#0a7c4e";
  if (s >= 55) return "#b45309";
  return "#3b5bdb";
}
function scoreBg(s) {
  if (s >= 75) return "#ecfdf5";
  if (s >= 55) return "#fffbeb";
  return "#eef1fd";
}
function scoreBorder(s) {
  if (s >= 75) return "#a7f3d0";
  if (s >= 55) return "#fde68a";
  return "#c5cff7";
}

export default function Demo({ onSubscribe, onBack }) {
  return (
    <div style={{ minHeight: "100vh", background: "#f7f7f5", fontFamily: "Inter, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        .unlock-btn:hover { background: #3451c7 !important; transform: translateY(-1px); }
        @media (max-width: 640px) {
          .demo-nav-tag { display: none !important; }
        }
      `}</style>

      <UrgencyBanner />
      {/* Nav */}
      <div style={{ borderBottom: "1px solid #e8e8e4", padding: "14px 20px", background: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
          <span style={{ fontSize: 18, fontWeight: 800, color: "#1a1a1a" }}>PDFTopicScout</span>
          <span className="demo-nav-tag" style={{ fontSize: 12, color: "#3b5bdb", fontWeight: 600 }}>by Creatovate</span>
        </button>
        <button onClick={onSubscribe} style={{
          background: "#3b5bdb", color: "#fff", border: "none", borderRadius: 8,
          padding: "8px 16px", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "Inter, sans-serif", flexShrink: 0,
        }}>
          Get Started →
        </button>
      </div>

      <div style={{ maxWidth: 820, margin: "0 auto", padding: "36px 20px" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 32, animation: "fadeIn 0.5s ease" }}>
          <div style={{ display: "inline-block", background: "#eef1fd", border: "1px solid #c5cff7", borderRadius: 20, padding: "4px 14px", fontSize: 12, color: "#3b5bdb", fontWeight: 600, marginBottom: 12 }}>
            🔍 Live Preview
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>
            See PDFTopicScout in action
          </h1>
          <p style={{ fontSize: 15, color: "#999", lineHeight: 1.6 }}>
            Here's a sample of what you get. Subscribe to unlock all 20 topics, AI insights, and PDF outlines.
          </p>
        </div>

        {/* Topic cards */}
        <div style={{ position: "relative" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {DEMO_TOPICS.map((t, i) => {
              const blurred = i >= 2;
              return (
                <div key={i} style={{
                  background: "#fff", border: "1px solid #e8e8e4", borderRadius: 10,
                  padding: "16px 18px", animation: `fadeIn 0.3s ease ${i * 0.08}s both`,
                  filter: blurred ? "blur(4px)" : "none",
                  userSelect: blurred ? "none" : "auto",
                  pointerEvents: blurred ? "none" : "auto",
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a1a", marginBottom: 10 }}>{t.topic}</div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        <span style={{ fontSize: 12, background: "#eef1fd", border: "1px solid #c5cff7", borderRadius: 20, padding: "2px 9px", color: "#3b5bdb", fontWeight: 600 }}>
                          Virality: {t.virality}
                        </span>
                        <span style={{ fontSize: 12, background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 20, padding: "2px 9px", color: "#0a7c4e", fontWeight: 600 }}>
                          Competition: {t.competition}
                        </span>
                        <span style={{ fontSize: 12, background: "#f7f7f5", border: "1px solid #e8e8e4", borderRadius: 20, padding: "2px 9px", color: "#666", fontWeight: 500 }}>
                          {t.audience.split(",")[0].trim()}
                        </span>
                      </div>
                    </div>
                    <div style={{
                      display: "inline-flex", flexDirection: "column", alignItems: "center",
                      background: scoreBg(t.score), border: `1px solid ${scoreBorder(t.score)}`,
                      borderRadius: 8, padding: "6px 12px", minWidth: 72, flexShrink: 0,
                    }}>
                      <span style={{ fontSize: 20, fontWeight: 800, color: scoreColor(t.score), lineHeight: 1 }}>{t.score}</span>
                      <span style={{ fontSize: 9, color: scoreColor(t.score), fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", marginTop: 2, opacity: 0.8 }}>Sellability</span>
                    </div>
                  </div>
                  {!blurred && (
                    <div style={{ marginTop: 12 }}>
                      <button style={{
                        background: "transparent", border: "1px solid #e8e8e4", color: "#aaa",
                        borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: 500,
                        cursor: "not-allowed", fontFamily: "Inter, sans-serif",
                      }}>
                        🔒 Show insight — subscribers only
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Overlay */}
          <div style={{
            position: "absolute", bottom: 0, left: 0, right: 0, height: "68%",
            background: "linear-gradient(to bottom, rgba(247,247,245,0) 0%, rgba(247,247,245,0.97) 35%)",
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end",
            paddingBottom: 32,
          }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 13, color: "#999", marginBottom: 12 }}>
                🔒 <strong style={{ color: "#1a1a1a" }}>15 more topics</strong> hidden · AI insights · PDF outlines
              </div>
              <button className="unlock-btn" onClick={onSubscribe} style={{
                background: "#3b5bdb", color: "#fff", border: "none", borderRadius: 10,
                padding: "14px 32px", fontWeight: 700, fontSize: 15, cursor: "pointer",
                transition: "all 0.2s", boxShadow: "0 4px 16px rgba(59,91,219,0.3)",
                fontFamily: "Inter, sans-serif",
              }}>
                See Plans →
              </button>
              <div style={{ fontSize: 12, color: "#aaa", marginTop: 10 }}>From $7.99/mo · Cancel anytime</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
